import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_2 = {
  key: 2,
  class: "empty-state"
}
const _hoisted_3 = {
  key: 3,
  class: "empty-state"
}

import { computed, onMounted, ref } from "vue";
import {
  IonButton,
  IonButtons,
  IonCheckbox,
  IonChip,
  IonContent,
  IonFab,
  IonFabButton,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonNote,
  IonRow,
  IonSearchbar,
  IonSpinner,
  IonTitle,
  IonToolbar,
  modalController
} from "@ionic/vue";
import { closeOutline, saveOutline } from 'ionicons/icons';
import { useStore } from "vuex";
import { translate } from '@hotwax/dxp-components';


export default /*@__PURE__*/_defineComponent({
  __name: 'AddProductFiltersModal',
  props: ["label", "facetToSelect", "searchfield", "type"],
  setup(__props) {

const facetOptions = ref([]) as any;
const queryString = ref('');
const selectedValues = ref([]) as any;
const filteredOptions = ref([]) as any;

const isLoading = ref(false);

const props = __props;
const store = useStore();

const appliedFilters = computed(() => store.getters["util/getAppliedFilters"]);
const getFacetOptions = computed(() => store.getters["util/getFacetOptions"]);

onMounted(async() => {
  isLoading.value = true;
  await store.dispatch("util/fetchProductFilters", { facetToSelect: props.facetToSelect, searchfield: props.searchfield })
  facetOptions.value = getFacetOptions.value(props.searchfield);
  filteredOptions.value = JSON.parse(JSON.stringify(facetOptions.value))
  selectedValues.value = JSON.parse(JSON.stringify(appliedFilters.value[props.type][props.searchfield]))
  isLoading.value = false;
})

function closeModal() {
  modalController.dismiss({ dismissed: true });
}

async function search() {
  filteredOptions.value = []

  if(queryString.value.trim()) {
    isLoading.value = true;
    await store.dispatch("util/fetchProductFilters", { facetToSelect: props.facetToSelect, searchfield: props.searchfield, queryString: queryString.value.trim() })
    filteredOptions.value = getFacetOptions.value(props.searchfield).filter((option: any) => option.label.toLowerCase().includes(queryString.value.trim().toLowerCase()))
    isLoading.value = false;
  } else {
    filteredOptions.value = JSON.parse(JSON.stringify(getFacetOptions.value(props.searchfield)))
  }
}

function updateSelectedValues(value: string) {
  selectedValues.value.includes(value) ? selectedValues.value.splice(selectedValues.value.indexOf(value), 1) : selectedValues.value.push(value);
}

function isAlreadyApplied(value: string) {
  const type = props.type === 'included' ? 'excluded' : 'included'
  return appliedFilters.value[type][props.searchfield].includes(value)
}

async function saveFilters() {
  const selectedFilters = JSON.parse(JSON.stringify(appliedFilters.value))
  selectedFilters[props.type][props.searchfield] = selectedValues.value

  await store.dispatch('util/updateAppliedFilters', selectedFilters)
  modalController.dismiss()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonHeader), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonToolbar), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonButtons), { slot: "start" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonButton), { onClick: closeModal }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), {
                      slot: "icon-only",
                      icon: _unref(closeOutline)
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(IonTitle), null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.type === "included" ? _unref(translate)("Include", { label: __props.label }) : _unref(translate)("Exclude", { label: __props.label })), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(IonButtons), { slot: "end" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonButton), {
                  fill: "clear",
                  color: "danger",
                  disabled: !facetOptions.value.length || !selectedValues.value.length,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (selectedValues.value = []))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(translate)("Clear All")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(IonContent), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonSearchbar), {
          placeholder: _unref(translate)('Search', { label: __props.label }),
          modelValue: queryString.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((queryString).value = $event)),
          onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (search()), ["enter"]))
        }, null, 8, ["placeholder", "modelValue"]),
        _createVNode(_unref(IonRow), null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedValues.value, (filter) => {
              return (_openBlock(), _createBlock(_unref(IonChip), {
                outline: "",
                key: filter.id
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonLabel), null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(filter), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }),
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_unref(IonItem), { lines: "none" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonSpinner), {
                    name: "crescent",
                    slot: "start"
                  }),
                  _createTextVNode(" " + _toDisplayString(_unref(translate)("Fetching filters")), 1)
                ]),
                _: 1
              })
            ]))
          : (filteredOptions.value.length)
            ? (_openBlock(), _createBlock(_unref(IonList), { key: 1 }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredOptions.value, (option) => {
                    return (_openBlock(), _createBlock(_unref(IonItem), {
                      key: option.id,
                      onClick: ($event: any) => (!isAlreadyApplied(option.id) ? updateSelectedValues(option.id) : null)
                    }, {
                      default: _withCtx(() => [
                        (isAlreadyApplied(option.id))
                          ? (_openBlock(), _createBlock(_unref(IonLabel), { key: 0 }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(option.label), 1)
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true),
                        (!isAlreadyApplied(option.id))
                          ? (_openBlock(), _createBlock(_unref(IonCheckbox), {
                              key: 1,
                              checked: selectedValues.value.includes(option.id)
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(option.label), 1)
                              ]),
                              _: 2
                            }, 1032, ["checked"]))
                          : (_openBlock(), _createBlock(_unref(IonNote), {
                              key: 2,
                              slot: "end",
                              color: "danger"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(__props.type === 'included' ? _unref(translate)("excluded") : _unref(translate)("included")), 1)
                              ]),
                              _: 1
                            }))
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  }), 128))
                ]),
                _: 1
              }))
            : (!queryString.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("p", null, _toDisplayString(_unref(translate)("Search for to find results", { label: __props.label })), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("p", null, _toDisplayString(_unref(translate)("No result found for", { label: queryString.value })), 1)
                ])),
        _createVNode(_unref(IonFab), {
          vertical: "bottom",
          horizontal: "end",
          slot: "fixed"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonFabButton), {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (saveFilters()))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonIcon), { icon: _unref(saveOutline) }, null, 8, ["icon"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})